import React, { FC } from 'react'
import { LinkWrapper } from '../LinkWrapper'
import { TableListColumnDefinition, TableListColumnProps } from './TableList'

export interface TableListItemProps extends TableListColumnProps {
  columnDefinition?: TableListColumnDefinition
  linkTextColor?: string
}

export const TableListItem: FC<TableListItemProps> = ({
  columnDefinition,
  isExternalLink,
  link,
  linkTextColor = 'text-primary',
  text,
}) => {
  const fontWeight = columnDefinition?.fontWeight ?? ''
  const gapX = columnDefinition?.gapX ?? ''
  const width = columnDefinition?.width ?? ''
  const align = columnDefinition?.alignment ?? ''

  return (
    <div className={`flex-1 ${width} ${fontWeight} ${gapX} ${align}`}>
      <LinkWrapper
        isExternal={isExternalLink}
        additionalLinkClassName={linkTextColor}
        url={link}
      >
        {text}
      </LinkWrapper>
    </div>
  )
}
